import i18n from '../../i18n';

const HeaderDropdownData = {
    "Services": [
        { title: i18n.t('data.software_development'), path: "/software-development" },
        { title: i18n.t('data.qt_code_quality_analysis'), path: "/qt-code-quality-analysis" },
        { title: i18n.t('data.qml_3d_drawing_solutions'), path: "/qml-3d-drawing" },
        { title: i18n.t('data.qt_qml_charts_and_graphs'), path: "/qt-charts-graphs" },
    ],
    "Training": [
        i18n.t('data.cpp_world'),
        i18n.t('data.modern_cpp'),
        i18n.t('data.qt'),
        i18n.t('data.qml_qt_quick')
    ]
};

export default HeaderDropdownData;